module.exports = __webpack_public_path__ + "img/5.d77cd930.png";